/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import buildIndividuUpdatePayload from './buildIndividuUpdatePayload';

/**
 * Construit le corps de `PUT /acte-individus/{identifiant}`.
 *
 * Cet endpoint est générique à tous les types d'acte, contrairement au PUT du
 * dossier de numérisation : il permet donc d'éditer les individus depuis la
 * fiche de reconnaissance, pour laquelle
 * `PUT /numerisation-actes/reconnaissance/{id}` n'existe pas.
 *
 * Le corps réutilise `buildIndividuUpdatePayload` — même fusion « champs lus +
 * champs édités », donc mêmes garanties : une modale ne peut pas écraser un
 * champ qu'elle n'édite pas.
 *
 * Deux différences avec le PUT du dossier, toutes deux volontaires :
 * - l'`identifiant` est retiré du corps : il vit dans l'URL ;
 * - `ai_sexel` n'étant pas recalculé côté serveur sur cette route, c'est
 *   `buildIndividuUpdatePayload` qui fournit `sexeLibelle`.
 *
 * ⚠️ Le quadruplet de rattachement (`tableacte`, `identifiantActe`,
 * `typeIndividuActe`, `identifiantEntite`) ne doit **jamais** figurer ici :
 * `ActeIndividuController::update` l'accepterait et détacherait l'individu de
 * son acte. Il est absent de `CHAMPS_INDIVIDU_FICHE`, donc jamais renvoyé.
 */
const buildIndividuPutPayload = (
  individu: Record<string, any> | undefined,
  data: Record<string, any>,
): Record<string, any> =>
  _.omit(buildIndividuUpdatePayload(individu, data), ['identifiant']);

export default buildIndividuPutPayload;
